import { PropertyConfig } from "../../../forms/propertyConfig";
import { PropertyConfigType } from "../../../forms/propertyConfig.types";
import { UnixTimestampIndeterminateInterval } from "../../../tools/timestamps.tools.definitions";
import { RegisterValidator, Validator } from "./validator";

export const requiredValidatorName = "required";
/**
 * This validator ensures a value is set
 * sample use in propertyConfig => validators: validatorEntry(RequiredValidator, true) or validators: { required: true } (second option requires this class to be loaded)
 */
@RegisterValidator(requiredValidatorName)
export class RequiredValidator implements Validator<unknown, boolean> {
    /** @returns true if property value is not null or undefined or empty string or an empty array */
    private _isPropertyValid(propertyValue: unknown): boolean {
        return propertyValue != null && propertyValue !== "" && !(Array.isArray(propertyValue) && propertyValue.length === 0) && !(typeof propertyValue === "number" && isNaN(propertyValue));
    }

    /**
     * @returns true if property value is valid
     * if property type is a date interval, check that start and finish properties are both valid
     */
    public isValid(property: PropertyConfig, propertyValue: unknown, validatorParams: boolean, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, unknown>): boolean {
        if (property.typeUid === PropertyConfigType.DATE_INTERVAL) {
            const dateInterval = <UnixTimestampIndeterminateInterval>propertyValue;
            return this._isPropertyValid(dateInterval?.start) && this._isPropertyValid(dateInterval?.finish);
        } else {
            return this._isPropertyValid(propertyValue);
        }
    }
}